import { useState, useEffect } from 'react';

function ContactForm({ onBack, onSubmit }) {
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, []);
  const [name,    setName]    = useState('');
  const [email,   setEmail]   = useState('');
  const [website, setWebsite] = useState('');
  const [errors,  setErrors]  = useState({});

  function validate() {
    const e = {};
    if (!name.trim())  e.name  = 'Name is required.';
    if (!email.trim()) e.email = 'Email is required.';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = 'Enter a valid email address.';
    return e;
  }

  function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    onSubmit({ name, email, website });
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit} noValidate>

      <p className="cf-title">Almost there — where should we send your analysis?</p>
      <p className="cf-sub">
        We'll tailor your deeper analysis and connect you with the right advisory team. No spam, ever.
      </p>

      {/* ── Contact fields ── */}
      <div className="cf-fields">
        <div className="cf-field">
          <label className="cf-field-label" htmlFor="cf-name">
            Full name <span className="cf-required">*</span>
          </label>
          <input
            id="cf-name"
            className={`form-input cf-input${errors.name ? ' input-error' : ''}`}
            type="text"
            placeholder="Jane Smith"
            value={name}
            autoFocus
            onChange={e => { setName(e.target.value); setErrors(p => ({ ...p, name: undefined })); }}
          />
          {errors.name && <p className="form-error">{errors.name}</p>}
        </div>

        <div className="cf-field">
          <label className="cf-field-label" htmlFor="cf-email">
            Work email <span className="cf-required">*</span>
          </label>
          <input
            id="cf-email"
            className={`form-input cf-input${errors.email ? ' input-error' : ''}`}
            type="email"
            placeholder="jane@agency.com"
            value={email}
            onChange={e => { setEmail(e.target.value); setErrors(p => ({ ...p, email: undefined })); }}
          />
          {errors.email && <p className="form-error">{errors.email}</p>}
        </div>

        <div className="cf-field">
          <label className="cf-field-label" htmlFor="cf-website">
            Agency website <span className="cf-optional">(optional)</span>
          </label>
          <input
            id="cf-website"
            className="form-input cf-input"
            type="url"
            placeholder="https://youragency.com"
            value={website}
            onChange={e => setWebsite(e.target.value)}
          />
        </div>
      </div>

      <p className="cf-privacy">
        We will never share your data. By submitting you agree to our{' '}
        <a href="/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
      </p>

      <div className="form-nav" style={{ marginTop: 24 }}>
        <button type="button" className="btn btn-outline" onClick={onBack}>
          Back
        </button>
        <button type="submit" className="btn">
          Next →
        </button>
      </div>

    </form>
  );
}

export default ContactForm;
